interface LoginState {
  loadingRegister: boolean;
  user: any;
  errors: any;
  redirect: any;
}

const defaultState: LoginState = {
  loadingRegister: false,
  user: {},
  errors: null,
  redirect: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case "LOGIN_CLEAR_ERRORS": {
      return {
        ...state,
        loading: false,
        invitationErrors: null,
        errors: null,
        user: null
      };
    }

    case "LOGIN_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case "LOGIN_FULFILLED": {
      // if there was an origin then redirect to it      
      const origin = action.meta.origin?.pathname;
      let redirect: string | null = null;
      if ((action.payload.needToTakePayment || action.payload.data?.needToTakePayment)) {
        redirect = '/payment';
      } else if ((action.payload.paymentPending || action.payload.data?.paymentPending)) {
        redirect = '/payment/complete';
      } else if ((action.payload.subscriptionPaused || action.payload.data?.subscriptionPaused)) {
        redirect = '/payment/resume-subscription';
      } else if (origin) {
        redirect = origin;
      } else {
        redirect = '/films';
      }

      return {
        ...state,
        invitationErrors: action.payload.data.invitationErrors,
        redirect: { to: redirect },
        loading: false
      };
    }

    case "LOGIN_REJECTED": {
      return {
        ...state,
        user: action.meta.user,
        authenticated: false,
        errors: action.payload.response.data.errors,
        invitationErrors: action.payload.response.data.invitationErrors,
        loading: false
      };
    }

    case "AUTHENTICATED": {
      return {
        ...state,
        authenticated: true
      };
    }

    case "RESEND_EMAIL_CONFIRMATION_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case "RESEND_EMAIL_CONFIRMATION_FULFILLED": {
      return {
        ...state,
        loading: false
      };
    }

    case "RESEND_EMAIL_CONFIRMATION_REJECTED": {
      return {
        ...state,
        user: action.meta.user,
        authenticated: false,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case "CLEAR_LOGIN_REDIRECT": {
      return {
        ...state,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default reducer;
